import DOMPurify from "dompurify";

const SANITIZE = {
  ALLOWED_TAGS: [
    "p",
    "br",
    "strong",
    "b",
    "em",
    "i",
    "u",
    "s",
    "del",
    "strike",
    "sub",
    "sup",
    "h1",
    "h2",
    "h3",
    "h4",
    "ul",
    "ol",
    "li",
    "a",
    "blockquote",
    "span",
    "div",
    "img",
    "pre",
    "code",
    "mark",
  ],
  ALLOWED_ATTR: ["href", "title", "target", "rel", "src", "alt", "style", "class", "colspan", "rowspan"],
  ALLOW_DATA_ATTR: false,
};

/**
 * HTML seguro para exibição (pré-visualização de proposta, atestado, etc.).
 */
export function sanitizeRichHtml(html) {
  if (!html || typeof html !== "string") return "";
  return DOMPurify.sanitize(html, {
    ...SANITIZE,
    ADD_ATTR: ["target"],
  });
}

/**
 * Conteúdo salvo em `cabecalho_texto` / `rodape_texto`: pode ser HTML (TipTap) ou texto puro legado.
 * Texto sem tags preserva quebras de linha na impressão / tela (como o antigo `whitespace-pre-wrap`).
 */
export function prepareRichHtmlForDisplay(html) {
  if (!html || typeof html !== "string") return "";
  const t = html.trim();
  if (!t) return "";
  if (!/<[a-z][\s\S]*>/i.test(t)) {
    return t
      .split("\n")
      .map((line) => DOMPurify.sanitize(line, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }))
      .join("<br />");
  }
  return sanitizeRichHtml(t);
}
